export default {
  transferOtp: '60d1d04856c50469610b128c',
  payeeOtp: '60d1d00c59b5d4496d2f87b3',
  registerMobileOtp: '60d1d0764fa62d11e51eeecc',
  accountCreateOtp: '63db8781d6fc05461f067cd2',
  merchantActivateOtp: '6204e2ad39bfb40fc116c635',
  merchantDeactivateOtp: '6204e2fddb121c083e279a3a'
};
